import { Component, OnInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { initFlowbite } from 'flowbite';
import { filter } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'trackngrow.eu';

  constructor(private update: SwUpdate) { }

  ngOnInit() {
    this.update.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe((evt: any) => {
        if (confirm("There is a new version available. Load New Version?")) {
          window.location.reload();
        }
      });

    initFlowbite();
    // let darkMode = localStorage.getItem("darkMode") === "true";

    // if (darkMode) {
    //   document.documentElement.classList.add("dark");
    // }
  }
}
